// Phone photos are often 4000px and several MB; a background never needs more
// than a large screen's worth. Scales the image down in the browser and
// re-encodes it as JPEG before it is uploaded. Smaller images pass through
// re-encoded but unscaled.
const resizeImage = (file, maxSide = 1920, quality = 0.85) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(url);
    canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('encode failed'))), 'image/jpeg', quality);
  };
  img.onerror = () => {
    URL.revokeObjectURL(url);
    reject(new Error('not an image'));
  };
  img.src = url;
});

export default resizeImage;
